var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _g, _path5, _path6, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

const SvgMedalWinner = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "12 12 97 97",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_131)",
    filter: "url(#filter0_d_1_131)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_131)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8064 68.071L58.9459 73.3478L40.3864 105.494L35.0594 93.6135L49.8064 68.071Z",
    fill: "#FFB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8064 68.071L40.6668 62.7943L22.1073 94.9404L35.0594 93.6135L49.8064 68.071Z",
    fill: "#FFB300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8453 68.071L53.7058 73.3478L72.2653 105.494L77.5923 93.6135L62.8453 68.071Z",
    fill: "#FFB300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8453 68.071L71.9849 62.7943L90.5444 94.9404L77.5923 93.6135L62.8453 68.071Z",
    fill: "#FFB300"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0456,
    cy: 45.9371,
    r: 31.9657,
    fill: "url(#paint0_linear_1_131)",
    stroke: "#765C00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0456,
    cy: 45.9372,
    r: 24.5619,
    fill: "#A88300"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 23,
    width: 50,
    height: 51
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.3567,
    cy: 48.5591,
    r: 24.619,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_131)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.0457,
    cy: 45.9369,
    r: 24.619,
    fill: "#C09525"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1783 28.8102L61.489 39.4315L72.1103 40.7592L64.817 48.9376L66.7996 60.6742L56.1783 55.3635L45.5569 60.6742L47.5573 48.9376L40.2463 40.7592L50.8676 39.4315L56.1783 28.8102Z",
    fill: "url(#paint1_linear_1_131)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6208 26.8623L29.0834 19.2415L25.6208 11.6208L33.2415 15.0834L40.8623 11.6208L37.3996 19.2415L40.8623 26.8623L33.2415 23.3996L25.6208 26.8623Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_131",
    x: -4,
    y: 0,
    width: 117,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_131",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_131",
    x: 21.3238,
    y: 10.8372,
    width: 80.9731,
    height: 106.409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_131",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_131",
    x1: 56.0456,
    y1: 14.4714,
    x2: 56.0456,
    y2: 77.4028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_131",
    x1: 56.1783,
    y1: 28.8102,
    x2: 56.1783,
    y2: 60.6742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE896"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 109,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMedalWinner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/medal-winner.d6dae6e4.svg";
export { ForwardRef as ReactComponent };